import store from "@/store";

const LOGIN_PAGE_NAME = "login";
const NOTFOUND_PAGE = "error_404";
const ROOT_PAGE_NAME = "root";
const SIGNUP_INVITE = "SignupInvite";
const VERIFYDEVICE_PAGE_NAME = "VerifyDevice";
const SIGNUP_RESETPASSWORD = "ResetPassword";
const SIGNUP_RESETOTP = "ResetOTP";

import { _getCusInvoices } from "@/api/billing";

export const authMiddleware = async (to, from) => {
    try {
        let { userData } = store.state;
        // console.log("userData in auth.js >>", JSON.stringify(userData));

        // 未登入
        if (userData.privilege == undefined) throw new Error("Login problem?");

        // 不信任裝置
        if (userData.validateNewEquip !== undefined) {
            // 屬於不信任裝置且不在verify-device頁面，進入verify-device頁面
            if (userData.validateNewEquip.isNeedToValidate && to.name !== VERIFYDEVICE_PAGE_NAME) {
                // console.log("屬於不信任裝置且不在verify-device頁面，進入verify-device頁面");
                return {
                    nextOption: {
                        path: "/verify-device",
                    },
                };
            }

            // 不需驗證裝置卻要進入verify-device頁面，導回首頁
            if (!userData.validateNewEquip.isNeedToValidate && to.name == VERIFYDEVICE_PAGE_NAME) {
                return {
                    nextOption: {
                        path: store.getters.landingPagePath,
                    },
                };
            }
        }

        // 已登入, 請求登入頁或是根目錄
        if (to.name === LOGIN_PAGE_NAME || to.name === ROOT_PAGE_NAME) {
            // console.log("want to go to login page", store.getters.landingPagePath);
            //有金流權限並且有給groupName而且有欠款
            if (store.state.platformPlan.multiTenancyConfigs.isAllowPaymentShow) {
                try {
                    // 沒有群組
                    if (store.state.queryGroupName == "all" && store.state.queryGroupName != "") {
                        throw new Error("No group");
                    }
                    let getCusInvoicesResult = await _getCusInvoices({
                        groupName: store.state.queryGroupName,
                        customerId: undefined,
                    });
                    let overdraftInvoice = getCusInvoicesResult.data.data.invoice.find((e) => e.status == "open");
                    if (store.state.queryGroupName && overdraftInvoice) {
                        return {
                            nextOption: {
                                path: "/account-info/payment",
                            },
                        };
                    } else {
                        throw new Error("No Outstanding Payment");
                    }
                } catch (error) {
                    console.log("error:", error.message);
                    return {
                        nextOption: {
                            path: store.getters.landingPagePath,
                        },
                    };
                }
            } else {
                return {
                    nextOption: {
                        path: store.getters.landingPagePath,
                    },
                };
            }
        }

        // 用戶有權限
        if (to.meta.rule.indexOf(userData.privilege) > -1) {
            // console.log("want to go to some page");
            return {
                nextOption: {},
            };
        }

        // 用戶沒權限
        return {
            nextOption: {
                path: store.getters.landingPagePath,
            },
        };
    } catch (err) {
        // console.log(err);
        if (to.name === SIGNUP_INVITE) {
            // console.log("未登錄且要跳轉的頁面是註冊邀請頁");
            throw { nextOption: {} };
        } else if (to.name === SIGNUP_RESETPASSWORD) {
            // console.log("未登錄且要跳轉的頁面是重新設定密碼頁");
            throw { nextOption: {} };
        } else if (to.name === SIGNUP_RESETOTP) {
            // console.log("未登錄且要跳轉的頁面是重新設定OTP頁");
            throw { nextOption: {} };
        } else if (to.name === LOGIN_PAGE_NAME) {
            // console.log("未登錄且要跳轉的頁面是登錄頁");
            throw { nextOption: {} };
        } else {
            // console.log("未登錄且要跳轉的頁面不是登錄頁");
            throw {
                nextOption: {
                    path: LOGIN_PAGE_NAME,
                },
            };
        }
    }
};



// WEBPACK FOOTER //
// ./src/libs/routerMiddleware/auth.js